export default __webpack_public_path__ + "static/media/teresa-soop.cafb43bd.jpg";